module.exports = __webpack_public_path__ + "static/media/done.39e07490.svg";